import styled from 'styled-components';
import { Overline, H4, colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { Card } from '../Index/BillingPage.styled';

export const Container = styled(Card)`
  display: grid;
  grid-template-areas: 'header' 'marquee' 'table';
`;

export const Header = styled.div`
  align-items: center;
  display: flex;
  border-bottom: solid ${spacing.single} ${colors.grey15};
  grid-area: header;
  justify-content: space-between;
  padding: ${pxToRem(20)} ${spacing.plusHalf};
`;

export const Title = styled(H4)`
  margin-bottom: 0;
`;

export const TableHeadingRow = styled.div`
  align-items: center;
  display: grid;
  grid-template-columns: 1fr ${(props) => `repeat(2, ${props.theme.spacing.utils.pxToRem(160)})`};
  padding: ${spacing.threeQuarter} ${spacing.plusHalf};
`;

export const TableHeading = styled(Overline)`
  color: ${colors.textSecondary};
  display: block;
`;

export const Marquee = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 33.333%));
  margin-bottom: ${spacing.threeQuarter};
`;

export const MainContent = styled.div``;

export const LoadingMainContent = styled.div`
  padding: ${pxToRem(20)} ${spacing.plusHalf};
`;

export const RowsWrapper = styled.div`
  margin-bottom: ${spacing.plusHalf};

  & > *:nth-of-type(odd) {
    background-color: ${colors.grey1};
  }
`;
